<template>
  <div>
    <v-card>
      <ConfirmAbsentDialog
        :state="confirmMarkDialog"
        :importedDocuments="importedDocuments"
        @closeDialog="closeConfirmDialog"
        @updateResult="onUpdateResultDocument"
        ref="absentDialog"
      />
      <UpdateAbsentForm :state="updateDialog" :data="item" @closeDialog="closeUpdate" @refresh="refresh" />

      <InvalidStatusDialog :invalidStatus="invalidStatus" :state="invalidDialog" @closeDialog="closeInvalid" />
      <div class="pa-6">
        <div class="full-width text-end">
          <v-menu open-on-hover bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mt-0 mb-6" color="green" dark v-bind="attrs" v-on="on" outlined> Nhập/xuất Excel </v-btn>
            </template>

            <v-list>
              <v-list-item class="cursor-pointer">
                <v-list-item-title @click="onUploadClick">Tải lên tệp Excel chứa biên bản</v-list-item-title>
                <input
                  ref="uploader"
                  type="file"
                  class="d-none"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  @change="onFileChanged"
                />
              </v-list-item>
              <v-list-item class="cursor-pointer">
                <v-list-item-title @click="exportDataToExcel">Tải xuống tệp Excel mẫu</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <v-card outlined>
          <v-data-table
            item-key="id"
            :headers="headers"
            :loading="loading"
            :items="marks"
            :items-per-page="-1"
            :disable-sort="$vuetify.breakpoint.smAndDown"
            hide-default-footer
            v-bind="this.$attrs"
            fixed-header
          >
            <template v-slot:[`item.examCode`]="{ item }">
              {{ item.examCode || '-' }}
            </template>
            <template v-slot:[`item.student.name`]="{ item }">
              <div style="height: 100%">
                <StudentNameCard :item="item.student" />
              </div>
            </template>
            <template v-slot:[`item.note`]="{ item }">
              {{ item.note || '-' }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              {{ item.status | getStatus }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" @click="update(item)" v-bind="attrs" v-on="on" icon>
                      <v-icon> mdi-pencil </v-icon>
                    </v-btn>
                  </template>
                  <span>Chỉnh sửa biên bản</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { ExamMark } from '@/plugins/api'
import readXlsxFile from 'read-excel-file'
import * as XLSX from 'xlsx'
import StudentNameCard from './StudentNameCard.vue'
import ConfirmAbsentDialog from './ConfirmAbsentDialog.vue'
import InvalidStatusDialog from './InvalidStatusDialog.vue'
import UpdateAbsentForm from './UpdateAbsentForm.vue'

const originHeaders = [
  {
    text: 'Tên học sinh',
    value: 'student.name',
    align: 'left',
    sortable: false,
    width: '38%'
  },
  {
    text: 'Số báo danh',
    value: 'examCode',
    align: 'left',
    sortable: false,
    show: true,
    width: '18%'
  },
  {
    text: 'Trạng thái',
    value: 'status',
    align: 'left',
    sortable: false,
    show: false,
    width: '18%'
  },
  {
    text: 'Ghi chú',
    value: 'note',
    align: 'left',
    sortable: false,
    show: false,
    width: '18%'
  },
  {
    text: 'Thao tác',
    value: 'action',
    align: 'left',
    sortable: false,
    show: false,
    width: '8%'
  }
]
const schema = {
  id: {
    prop: 'id',
    type: String,
    required: true
  },
  'Họ tên': {
    prop: 'name',
    type: String,
    required: true
  },
  'Số báo danh': {
    prop: 'examCode',
    type: String
  },
  'Trạng thái': {
    prop: 'status',
    type: String
  },
  'Ghi chú': {
    prop: 'note',
    type: String
  }
}

export default {
  props: {
    query: Object
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      marks: [],
      item: {},
      importedDocuments: [],
      confirmMarkDialog: false,
      invalidDialog: false,
      updateDialog: false,
      invalidStatus: '',
      json_fields: {
        id: 'id',
        'Họ tên': 'student.name',
        'Số báo danh': 'examCode',
        'Trạng thái': 'status',
        'Ghi chú': 'note'
      }
    }
  },
  computed: {},
  methods: {
    ...mapActions('examMark', ['fetchMarks', 'countMarks']),
    async refresh() {
      this.$loading.active = true
      this.loading = true
      try {
        const fetchedMarks = await this.fetchMarks({
          ...this.query,
          _limit: -1,
          _sort: 'examCode:ASC'
        })
        this.marks = fetchedMarks
      } catch (error) {
        this.$alert.error('Lỗi load thông tin học sinh')
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    },
    onUploadClick() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {
          schema
        })
      } catch (error) {
        console.error(error)
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }
      this.$alert.success('Đã đọc File thành công!')
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const data = readFileResult.rows
        this.importedDocuments = data
        this.confirmMarkDialog = true
      }
      this.$loading.active = false
    },
    formatDataForExport(data) {
      const statusTranslations = {
        present: 'Có thi',
        absent: 'Vắng thi',
        suspended: 'VPQC',
        empty: 'Chưa có'
      }

      return data.map(item => {
        let formattedItem = {}
        for (let key in this.json_fields) {
          const fieldInfo = this.json_fields[key]
          let value = item

          if (typeof fieldInfo === 'string') {
            const pathParts = fieldInfo.split('.')
            pathParts.forEach(part => {
              if (value) {
                value = value[part]
              }
            })
          } else if (typeof fieldInfo === 'object') {
            value = item[fieldInfo.field]
            if (fieldInfo.callback) {
              value = fieldInfo.callback(value)
            }
          }

          if (key === 'Trạng thái' && statusTranslations[value]) {
            value = statusTranslations[value]
          }

          formattedItem[key] = value || ''
        }
        return formattedItem
      })
    },
    async onUpdateResultDocument(data) {
      this.$refs.uploader.value = null
      const updateData = {
        marks: data,
        room: this.query.room,
        subject: this.query.subject
      }
      const updated = await ExamMark.updateStatus(updateData)
      if (updated.invalidStatus) {
        this.$refs.absentDialog.stopLoading()
        this.invalidStatus = updated.invalidStatus
        this.invalidDialog = true
      } else {
        this.closeConfirmDialog()
        this.refresh()
      }
    },
    closeConfirmDialog() {
      this.confirmMarkDialog = false
      this.$refs.uploader.value = null
    },
    exportDataToExcel() {
      const formattedData = this.formatDataForExport(this.marks)
      const worksheet = XLSX.utils.json_to_sheet(formattedData)

      this.setColumnWidths(worksheet, formattedData)

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Marks')

      XLSX.writeFile(workbook, 'bien-ban-thi-mau.xlsx')
      this.$loading.active = false
    },
    closeInvalid() {
      this.invalidDialog = false
      this.invalidRooms = ''
    },
    update(item) {
      this.item = item
      this.updateDialog = true
    },
    closeUpdate() {
      this.updateDialog = false
    },
    setColumnWidths(worksheet, data) {
      let maxWidths = []
      const columnNames = data.length > 0 ? Object.keys(data[0]) : []

      columnNames.forEach((name, index) => {
        maxWidths[index] = name.length
      })

      data.forEach(row => {
        columnNames.forEach((name, index) => {
          const value = (row[name] || '').toString().trim()
          maxWidths[index] = Math.max(maxWidths[index], value.length)
        })
      })

      worksheet['!cols'] = maxWidths.map((width, index) => {
        if (columnNames[index] === 'id') {
          return { width, hidden: true }
        }
        return { width }
      })
    }
  },
  watch: {
    query: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refresh()
        }
      }
    }
  },
  filters: {
    getStatus: status => {
      if (status === 'present') return 'Có thi'
      else if (status === 'absent') return 'Vắng thi'
      else if (status === 'suspended') return 'VPQC'
      else return 'Chưa có'
    }
  },
  components: { StudentNameCard, ConfirmAbsentDialog, InvalidStatusDialog, UpdateAbsentForm }
}
</script>
